module.exports = __webpack_public_path__ + "img/double-ring-laoder.5d730378.svg";